<spark-layout>

  <!-- slot / content -->
  <layout-content>

    <h2>Settings</h2>
    <app-provider-settings-display></app-provider-settings-display>

  </layout-content>

</spark-layout>

